define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");
    var LE = require("app");

    var NO_LOBS_VALUE = "-1";

    var ContentCannedGridViewModel;

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentCannedGridViewModel = BaseModel.extend({
            name: "ContentCannedGridViewModel",
            NO_LOBS_VALUE: NO_LOBS_VALUE,
            defaults: {
                filters: {
                    "statusBoolean": [],
                    "categories": [],
                    "skills": [],
                    "languages": [],
                    "lobs": []
                },
                comparators: {
                    "name": "name",
                    "status": "status",
                    "hotkeys": "hotkeys"
                }
            },

            pluck: function (_model) {
                return true;
            },

            setFilterValue: function(filterName, filterValue){
                if(!_.isUndefined(this.get("filters." + filterName))){
                    this.set("filters." + filterName, filterValue);
                }
            },

            getFilterValue: function(filterName){
                return this.get("filters." + filterName);
            },

            predicate: function (model) {
                var modelIsInSelection = true;
                var passFilter;

                var contentLobs = model.getLobs();


                // if lob feature enabled - pre filter - filter always by user lobIds - no matter what is set in the filters attribute
                if (LE.sessionManager.hasEntitiesTaggingByLobFeature()) {
                    passFilter = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isLobAllowedForUser, contentLobs);
                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                //check if model lob is in selection:
                var filteredLobs = this.get("filters.lobs");
                if (!_.isEmpty(filteredLobs)) {
                    passFilter = false;
                    _.each(filteredLobs, function (filteredLobId) {
                        if (_.intersection(contentLobs, filteredLobs).length > 0 || (_.isEmpty(contentLobs) && (filteredLobId === NO_LOBS_VALUE))) { // in case of "unassigned", the lobId in filters will be NO_LOBS_VALUE and the content lobs is empty
                            passFilter = true;
                        }
                    });
                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                //check if model status is in selection:
                if(!_.isEmpty(this.get("filters.statusBoolean"))){
                    passFilter = false;
                    _.each(this.get("filters.statusBoolean"), function (status) {
                        if (model.getEnabledState() === status) {
                            passFilter = true;
                        }
                    });
                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                //check if model category is in selection:
                if(!_.isEmpty(this.get("filters.categories"))) {
                    passFilter = false;
                    _.find(this.get("filters.categories"), function (category) {
                        if (_.indexOf(model.getCategories(), category) !== -1) {
                            passFilter = true;
                            return true;
                        }
                    });
                    modelIsInSelection = modelIsInSelection && passFilter;
                }
                if(!_.isEmpty(this.get("filters.skills"))) {
                    passFilter = false;
                    _.find(this.get("filters.skills"), function(skills){
                        if (_.indexOf(model.getSkills(), skills) !== -1) {
                            passFilter = true;
                            return true;
                        }

                    });
                   modelIsInSelection = modelIsInSelection && passFilter;
                }


                //check if model language is in selection:
                if(!_.isEmpty(this.get("filters.languages"))) {
                    passFilter = false;
                    _.find(this.get("filters.languages"), function (language) {
                        if (_.indexOf(model.getLanguages(), language) !== -1) {
                            passFilter = true;
                            return true;
                        }
                    });
                    modelIsInSelection = modelIsInSelection && passFilter;
                }

                return modelIsInSelection;

            }
        });
    });

    return ContentCannedGridViewModel;
});
